<template lang="pug">
  AppLayout(:title="title")
    DataTable(ref="dataTable", title="Global Tags", endpoint="global-tags", :sort="{name: 'asc'}", searchable)
      template(v-slot:buttons)
        Button(type="primary", @click="addGlobalTag()") Add Global Tag
      template(v-slot:rows="rows")
        DataTableRow(v-for="(row, i) in rows", :key="i", :row="row")
          DataTableColumn(title="Tag", sortable="name")
            Icon(icon="tag", class="mr-2")
            span {{ row.name }}
          //- DataTableColumn(title="content", icon="content", width="max", sortable="content_count") {{ row.content_count | number | default('0') }}
          DataTableColumn(title="Added", sortable="created_at", width="max") {{ row.created_at | datetime }}
          template(v-slot:actions)
            Dropdown.flip-menu(icon="ellipsis-v")
              DropdownLink(icon="pencil", @click="editGlobalTag(row)") Edit
              DropdownLink(icon="trash", @click="deleteGlobalTag(row)") Delete
</template>

<script>
import AddGlobalTagModal from "@/modals/GlobalTags/AddGlobalTagModal"
import EditGlobalTagModal from "@/modals/GlobalTags/EditGlobalTagModal"
import { MediaIcon } from "@syntax51/app-kit"

export default {
  components: {
    MediaIcon
  },
  metaInfo() {
    return { title: this.title, bodyAttrs: { class: "page-global-tags" } }
  },
  data: () => ({
    title: "Global Tags"
  }),
  methods: {
    async addGlobalTag() {
      if (await this.$modal.show(AddGlobalTagModal)) {
        this.$refs.dataTable.reload()
      }
    },
    async editGlobalTag(tag) {
      if (await this.$modal.show(EditGlobalTagModal, { endpoint: `global-tags/${tag.id}` })) {
        this.$refs.dataTable.reload()
      }
    },
    async deleteGlobalTag(tag) {
      if (
        await this.$modal.confirm({
          type: "danger",
          message: `Are you sure you want to delete global tag **${tag.name}**?`,
          buttonText: "Delete"
        })
      ) {
        if (await this.$api.delete(`global-tags/${tag.id}`)) {
          this.$notification.success(`Global tag **${tag.name}** successfully deleted.`)
          this.$refs.dataTable.reload()
        }
      }
    }
  }
}
</script>
